class Product {
  constructor() {
    this.acc = [];
    this.container = document.querySelector(".m-main-product");
    MinimogTheme.CompareProduct && MinimogTheme.CompareProduct.setCompareButtonsState();
    MinimogTheme.Wishlist && MinimogTheme.Wishlist.setWishlistButtonsState();
    this.addRecentViewedProduct();

    addEventDelegate({
      context: this.container,
      selector: (window.__minimog_review_selector || '') + '.m-product-collapsible .jdgm-widget-actions-wrapper, .m-product-collapsible .spr-summary-actions-newreview',
      handler: (e) => {
      const index = e.target.closest('.m-product-collapsible').dataset.index
      setTimeout(() => {
        this.acc[Number(index)].setContentHeight()
      }, 300)},
      capture: true
    })
  }

  addRecentViewedProduct() {
    const cookies = getCookie('m-recent-viewed-products')
    let products = cookies ? JSON.parse(cookies) : []
    if (products.indexOf(MinimogSettings.productHandle) === -1) {
      products.unshift(MinimogSettings.productHandle)
      products = products.slice(0, 20)
      setCookie('m-recent-viewed-products', JSON.stringify(products));
    }
  }
}

// new Product();

// Sincronización de precio con scroll de imágenes (desktop y móvil optimizado)
const initPriceSync = () => {
  const checkSwiper = setInterval(() => {
    const swiperWrapper = document.querySelector('.swiper-wrapper');
    const priceElement = document.querySelector('.m-price-item--regular');
    
    if (swiperWrapper && priceElement) {
      clearInterval(checkSwiper);
      setupPriceObserver(swiperWrapper);
    }
  }, 500);
  
  setTimeout(() => clearInterval(checkSwiper), 10000);
};

const setupPriceObserver = (swiperWrapper) => {
  let updateTimeout;
  
  // Observer para detectar cambios de clase
  const observer = new MutationObserver(() => {
    clearTimeout(updateTimeout);
    updateTimeout = setTimeout(updatePriceFromActiveSlide, 100);
  });
  
  observer.observe(swiperWrapper, {
    attributes: true,
    subtree: true,
    attributeFilter: ['class']
  });
  
  // Event listeners para móvil con múltiples intentos
  swiperWrapper.addEventListener('touchend', () => {
    setTimeout(updatePriceFromActiveSlide, 100);
    setTimeout(updatePriceFromActiveSlide, 300);
    setTimeout(updatePriceFromActiveSlide, 500);
  });
  
  swiperWrapper.addEventListener('transitionend', () => {
    updatePriceFromActiveSlide();
  });
  
  // Listener adicional para cuando Swiper cambia de slide
  const swiperContainer = swiperWrapper.closest('.swiper-container') || 
                         swiperWrapper.closest('.swiper');
  
  if (swiperContainer && swiperContainer.swiper) {
    swiperContainer.swiper.on('slideChange', function() {
      updatePriceFromActiveSlide();
    });
  }
  
  console.log('✓ Sincronización de precio activada (desktop y móvil optimizado)');
};

const updatePriceFromActiveSlide = () => {
  const activeSlide = document.querySelector('.swiper-slide-active');
  
  if (activeSlide) {
    const mediaId = activeSlide.getAttribute('data-media-id');
    if (mediaId) {
      updatePrice(mediaId);
    }
  }
};

const updatePrice = (mediaId) => {
  const scripts = document.querySelectorAll('script[id*="productVariants"]');
  let variants = [];
  
  scripts.forEach(script => {
    try {
      const data = JSON.parse(script.textContent);
      if (Array.isArray(data)) {
        variants = data;
      }
    } catch (e) {}
  });
  
  const variant = variants.find(v => 
    v.featured_media && String(v.featured_media.id) === String(mediaId)
  );
  
  if (variant && variant.price) {
    // Buscar TODOS los elementos de precio y actualizarlos
    const priceElements = document.querySelectorAll('.m-price-item--regular');
    const price = '$' + (variant.price / 100).toFixed(2);
    
    priceElements.forEach(priceElement => {
      if (priceElement && priceElement.offsetParent !== null) { // Solo elementos visibles
        priceElement.textContent = price;
      }
    });
    
    console.log('Precio actualizado:', price, 'Media ID:', mediaId, 'Elementos actualizados:', priceElements.length);
  }
};

// Iniciar
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPriceSync);
} else {
  initPriceSync();
}
new Product();
